export default {
  info: 'Información',
  edit: 'Editar',
  comments: 'Comentar',
  link: 'Enlace',
  pdf: 'Subir PDF',
  image: 'Subir imagen',
  video: 'Subir vídeo',
  removeFile: 'Eliminar',
  commentPlaceholder: 'Responder',
  emptyComments: 'No hay comentarios',
  emptyCommentsPlaceholder: 'Agregar un comentario',
  resolveThread: 'Resolver conversación',
  insertLinkPlaceholder: 'Inserta un enlace aquí'
}

export const en = {
  info: 'Information',
  edit: 'Edit',
  comments: 'Comment',
  link: 'Link',
  pdf: 'Upload PDF',
  image: 'Upload image',
  video: 'Upload video',
  removeFile: 'Delete',
  commentPlaceholder: 'Reply',
  emptyComments: 'No comments',
  emptyCommentsPlaceholder: 'Add comment',
  resolveThread: 'Solve conversation',
  insertLinkPlaceholder: 'Insert link here'
}

export const ca = {
  info: 'Informació',
  edit: 'Editar',
  comments: 'Comentar',
  link: 'Enllaç',
  pdf: 'Carregar PDF',
  image: 'Carregar imatge',
  video: 'Carregar vídeo',
  removeFile: 'Eliminar',
  commentPlaceholder: 'Respondre',
  emptyComments: 'No hi ha comentaris',
  emptyCommentsPlaceholder: 'Afegir un comentari',
  resolveThread: 'Resoldre conversa',
  insertLinkPlaceholder: 'Insereix un enllaç aquí'
}
